const getUniqueFlatArray = <T extends string | number | boolean>(array: T[]): T[] =>
  array.filter((value, i) => array.indexOf(value) === i);

export default getUniqueFlatArray;
